import Vue from 'vue';
import Vuex from 'vuex';
import moment from 'moment';
import firebase from '../firebase'
import router from '../router'
import { EventBus } from '../views/bus.js';


Vue.use(Vuex);


function saveHistoryItem(key, historyItem, animal) {
  firebase.firestore.collection('users').doc(firebase.auth.currentUser.uid)
      .collection(animal).doc(key).collection('history')
      .add(historyItem).then(item => {
        console.log(item.id);
        return item.id;
  });
}

export default new Vuex.Store({
  state: {
    paddockName: '', // rancho actual
    paddocks: [], // ranchos en Firestore
    paddock: null,
    animalType: null, // el tipo de animal a renderizar, cows, bulls, heifers
    cows: [],
    bulls: [],
    ready: 0,
    heifers: [],
    groups: [], // grupos en Firestore
    group: [], // grupo actual
    defaultGroup: {}, // el grupo por defecto
    animals: '', // animales registrados en Firestore
    filteredCows: '', // animales filtrados para el componente GroupForm
    cowsInGroup: [], // animales filtrados según el grupo
    user: null,
    history: [],
    renderNav: false,
    userData: undefined,
    currentAnimal: '' // el animal actual en el que se están haciendo las modificaciones
  },
  getters: {
    getCows(state) {
      return state.cows.filter(cow => cow.paddock === state.paddock.name);
    },
    getReady(state) {
      return state.ready;
    },
    /**
     * Obtains an history of current animal
     * @param state
     * @returns {[]}
     */
    getHistory(state) {
      return state.history
    },
    getBulls(state) {
      return state.bulls;
    },
    getHeifers(state) {
      return state.heifers;
    },
    getHeiferGroups(state) {
      let heiferGroups = {};
      state.heifers.forEach(heifer => {
        if (heiferGroups[heifer.group] === undefined) {
          heiferGroups[heifer.group] = {
            number: 1,
            name: heifer.group
          };
        } else {
          heiferGroups[heifer.group].number++;
        }
      });
      return heiferGroups;
    },
    getCowGroups(state) {
      let cowGroups = {};
      state.cows.forEach(cow => {
        if (cowGroups[cow.group] === undefined) {
          cowGroups[cow.group] = {
            number: 1,
            name: cow.group
          };
        } else {
          cowGroups[cow.group].number++;
        }
      });
      return cowGroups;
    },
    getBullGroups(state) {
      let bullGroups = {};
      state.bulls.forEach(bull => {
        if (bullGroups[bull.group] === undefined) {
          bullGroups[bull.group] = {
            number: 1,
            name: bull.group
          };
        } else {
          bullGroups[bull.group].number++;
        }
      });
      return bullGroups;
    },
    getCowCount(state) {
      return state.cows.length;
    },
    animalTypeSelected(state) {
      return state.animalType;
    },
    getPaddockSelected(state) {
      return state.paddockName;
    },
    /**
     * Regresa todos los grupos en el sistema
     * @param state
     * @returns {*}
     */
    groups(state) {
      return state.groups;
    },
    getGroup(state) {
      return state.group;
    },
    getCurrentAnimal(state) {
      return state.currentAnimal;
    },
    getGroupsNumber(state) {
      return state.groups.length;
    },
    paddocks(state) {
      return state.paddocks;
    },
    paddock(state) {
      return state.paddock;
    },
    paddockName(state) {
      return state.paddock.name;
    },
    animalType(state) {
      return state.animalType;
    },
    getAnimals(state) {
      return state.animals;
    },
    getUser(state) {
      return state.user;
    },
    heiferGroups(state){
      let hGroups = state.groups.filter(cow => cow.type === 'heifer');
      let hAnimals = state.animals.filter(animal => moment().diff(animal.birthday, 'days') <= 390 && animal.sex);
      let hGroupsNumber = {};

      hAnimals.forEach(animal => {
        if (hGroupsNumber[animal.group] === undefined) {
          hGroupsNumber[animal.group] = {
            number: 1,
          };
        } else {
          hGroupsNumber[animal.group].number++;
        }
      });

      hGroups.forEach(group => {
        if (hGroupsNumber[group.name] !== undefined) {
          group.number = hGroupsNumber[group.name].number;
        }
      });

      return hGroups;
    },
    cowGroups(state) {
      let cGroups = state.groups.filter(cow => cow.type === 'cow');
      let cAnimals = state.animals.filter(animal => moment().diff(animal.birthday, 'days') > 390 && animal.sex);
      let cGroupsNumber = {};

      cAnimals.forEach(animal => {
        if (cGroupsNumber[animal.group] === undefined) {
          cGroupsNumber[animal.group] = {
            number: 1,
          };
        } else {
          cGroupsNumber[animal.group].number++;
        }
      });

      cGroups.forEach(group => {
        if (cGroupsNumber[group.name] !== undefined) {
          group.number = cGroupsNumber[group.name].number;
        }
      });
      return cGroups;
    },
    getRenderNav(state) {
      return state.renderNav;
    },
    getUserData(state) {
      return state.userData;
    },
    getFilteredCows(state) {
      return state.filteredCows;
    },
    getPaddocksNumber(state) {
      return state.paddocks.length;
    },
    getAnimalsNumber(state) {
      return state.animals.length;
    },
    /**
     * Regresa el número de vacas con un formato específico
     * @param state
     * @returns {string}
     */
    getCowsNumber(state) {
      let formattedCows = '';
      let tempAnimalsNumber = state.animals.filter(animal => moment().diff(animal.birthday, 'days') > 390 && animal.sex).length;
      if (tempAnimalsNumber < 10) {
        formattedCows = "00" + tempAnimalsNumber;
      } else if (tempAnimalsNumber < 100) {
        formattedCows = "0" + tempAnimalsNumber;
      } else if (tempAnimalsNumber < 1000) {
        formattedCows = tempAnimalsNumber;
      }
      return formattedCows;
    },
    formattedHeifersNumber(state) {
      let formattedHeifers = '';
      let tempHeifersNumber = state.animals.filter(animal => moment().diff(animal.birthday, 'days') <= 390 && animal.sex).length;
      console.log(tempHeifersNumber);
      if (tempHeifersNumber < 10) {
        formattedHeifers = "00" + tempHeifersNumber;
      } else if (tempHeifersNumber < 100) {
        formattedHeifers = "0" + tempHeifersNumber;
      } else if (tempHeifersNumber < 1000) {
        formattedHeifers = tempHeifersNumber;
      }
      return formattedHeifers;
    },
    animalsInGroup(state) {
      return state.cowsInGroup;
    }
  },
  mutations: {
    setPaddock(state, paddock) {
      localStorage.setItem('paddock', JSON.stringify(paddock));
      state.paddock = paddock;
    },
    setAnimalType(state, type) {
      localStorage.setItem('animalType', type);
      state.animalType = type;
    },
    changeCurrentAnimal(state, animal) {
      state.currentAnimal = animal;
    },
    changeSelectedGroupName(state, newName) {
      state.group.name = newName;
    },
    /**
     * Cambia la referencia del grupo por defecto
     * @param state el estado actual
     * @param group el grupo a cambiar
     */
    changeDefaultGroup(state, group) {
      state.defaultGroup = group;
    },
    /**
     * Cambia el grupo actualmente seleccionado en el estado
     * @param state el estado actual
     * @param group el grupo a cambiar
     */
    changeSelectedGroup(state, group) {
      state.group = group;
    },
    changeAnimalsInGroup(state, animals) {
      state.cowsInGroup = animals;
    },
    /**
     * Cambia el tipo de animal a nivel de aplicación
     * @param state el estado de la app
     * @param type el nuevo tipo a cambiar
     */
    changeAnimalType(state, type) {
      state.animalType = type;
    },
    /**
     * Cambia los grupos del estado actual
     * @param state
     * @param groups
     */
    loadGroups(state, groups) {
      state.groups = groups;
    },
    loadPaddocks(state, paddocks) {
      state.paddocks = paddocks;
    },
    setUser(state, user) {
      state.user = user;
    },
    setCows(state, savedCows) {
      console.log("SAVED COWS: ", savedCows)
      state.cows = savedCows;
    },
    setGroups(state, groups) {
      state.groups = groups;
    },
    setHst(state, hst) {
      state.history = hst;
    },
    setBulls(state, savedBulls) {
      state.bulls = savedBulls;
    },
    setHeifers(state, savedHeifers) {
      state.heifers = savedHeifers;
    },
    loadAnimals(state, animals) {
      // filtra únicamente los animales vivos
      let aliveAnimals = animals.filter(animal => !animal.deleted);
      state.animals = aliveAnimals;
    },
    renderNav(state, payload) {
      state.renderNav = payload;
    },
    userData(state, payload){
      state.userData = payload;
    },
    filterCows(state, filteredCows) {
      state.filteredCows = filteredCows;
    },
    updateGroupNumber(state, groups) {
      console.log("NEW GROUPS: ", groups);
      let entries = Object.keys(groups);
      let values = Object.values(groups);
      state.groups = state.groups.map(function (item) {
        item.number = values[entries.indexOf(item.name)]
        console.log(entries.indexOf(item.name))
        console.log(item)
        return item;
      });
    },
  },
  actions: {
    /**
     * Obtiene los datos del usuario actual desde Firestore
     * @param context
     */
    getUserData(context) {
      if (context.state.user != '') {
        firebase.firestore.collection('users').doc(firebase.auth.currentUser.uid).onSnapshot((doc) => {
          context.commit('userData', doc.data());
        })
      }
    },
    /**
     * Listen cow animals from firestore
     */
    listenCows(context) {
      let cowsRef = firebase.firestore.collection('users/' + firebase.auth.currentUser.uid + '/cows');
      let today = moment();
      cowsRef.onSnapshot((snap => {
        let groups = {};
        let savedCows = [];
        snap.forEach((cow) => {
          let tempCow = cow.data();
          tempCow.key = cow.id;
          if (Object.keys(groups).indexOf(tempCow.group) === -1) {
            groups[tempCow.group] = 1;
          } else {
            groups[tempCow.group]++;
          }

          // calculating the state and dim for every cow
          let calvingDate = tempCow.calving.date;
          if (calvingDate !== null && moment(calvingDate).add(220, 'd').isAfter(moment())) {
            let dim = moment().diff(moment(calvingDate), 'd');
            tempCow.state = 'Lactando'
            tempCow.dim = dim + 1;
          } else {
            tempCow.state = 'Seca'
            tempCow.dim = 0;
          }

          tempCow.ptNtn = null;
          tempCow.btNtn = null;

          tempCow.history = [];
          cowsRef.doc(cow.id).collection('history').get().then((hst) => {
            hst.forEach(hstItem => {
              let currentItem = hstItem.data();
              currentItem.key = hstItem.id;
              tempCow.history.push(currentItem);
            });
          });

          if (tempCow.pregDate !== null) {
            console.log("PREG PREG PREGG")
            let diff = today.diff(moment(tempCow.pregDate), 'd');
            if (diff < 238 && diff > 232) {
              console.log("DEBUG  BIRTHDAY NTN: ", tempCow.key);
              tempCow.btNtn = true;
            }
            savedCows.push(tempCow);
            console.log("PREG DEBUG: ", savedCows);

          } else {
            console.log("HEATS; HEASTS");
            let heatsRef = cowsRef.doc(tempCow.key).collection('/heats');
            heatsRef.get().then(heats => {
              heats.forEach(heat => {
                let tmpHeat = heat.data();
                if (tmpHeat.inseminated) {
                  console.log("DEBUG PREG NTN: ", tempCow.key);
                  let diff = today.diff(moment(tmpHeat.date), 'd');
                  if (diff < 48 && diff > 42) {
                    tempCow.ptNtn = heat.id;
                    return true;
                  }
                }
              });
              // saving cow
              savedCows.push(tempCow);
              console.log("HEAT DEBUG: ", savedCows);
            }).catch(err => {
              savedCows.push(tempCow);
              console.log("ERROR: ", err);
            });
          }

        });
        context.commit('updateGroupNumber', groups);
        context.commit('setCows', savedCows);
      }));
    },
    /*
    * listen history of animals from firestore
     */
    async listenHistory(context, payload) {
      let svdHst;
      await firebase.firestore.collection('users/' + firebase.auth.currentUser.uid + '/'
          + payload.type + '/' + payload.key + '/history').onSnapshot((queryHstSnap) => {
        svdHst = [];
        queryHstSnap.forEach(hstItem => {
          let tmpHstItem = hstItem.data();
          tmpHstItem.key = hstItem.id;
          svdHst.push(tmpHstItem);
        });
        context.commit('setHst', svdHst);
      });
    },
    /**
     * Listen bulls animals from firestore
     */
    listenBulls(context) {
      firebase.firestore.collection('users/' + firebase.auth.currentUser.uid + '/bulls').onSnapshot((snap => {
        let savedBulls = [];
        snap.forEach((bull) => {
          let tempBull = bull.data();
          tempBull.key = bull.id;
          // saving bull
          savedBulls.push(tempBull);
        });
        console.log("LISTENBULLS STORE: ", savedBulls)
        context.commit('setBulls', savedBulls);
      }));
    },
    /**
     * Listen heifers animals from firestore
     */
    listenHeifers(context) {
      firebase.firestore.collection('users/' + firebase.auth.currentUser.uid + '/heifers').onSnapshot((snap => {
        let savedHeifers = [];
        snap.forEach((heifer) => {
          let tempHeifer = heifer.data();
          tempHeifer.key = heifer.id;
          // saving bull
          savedHeifers.push(tempHeifer);
        });
        console.log("LISTENHEIFERS STORE: ", savedHeifers)
        context.commit('setHeifers', savedHeifers);
      }));
    },
    /**
     * Escucha los grupos en el sistema según el rancho actual
     * @param context
     */
    listenGroups(context) {
      let groupsPath = `users/${firebase.auth.currentUser.uid}/paddocks/${context.state.paddock.key}/groups`;
      let groups = {};
      firebase.firestore.collection(groupsPath).onSnapshot(snapshot => {
        let tmpGroups = [];
        snapshot.forEach(group => {
          let tmpGroup = group.data();
          tmpGroup.key = group.id;
          tmpGroup.number = 0;
          tmpGroups.push(tmpGroup);
        });

        if (context.state.cows.length !== 0) {
          context.state.cows.forEach(tempCow => {
            if (Object.keys(groups).indexOf(tempCow.group) === -1) {
              groups[tempCow.group] = 1;
            } else {
              groups[tempCow.group]++;
            }
          })
        }
        context.commit('setGroups', tmpGroups);
        context.commit('updateGroupNumber', groups);
      });
    },
    /**
     * Añade un nuevo grupo a la base de datos, según el rancho actual
     * @param context el contexto de la store
     * @param group el nuevo grupo a añadir
     */
    saveGroup(context, group) {
      let groupPath = `/users/${firebase.auth.currentUser.uid}/paddocks/${context.getters.paddock.key}/groups`;
      firebase.firestore.collection(groupPath).add({
        type: 'cow',
        description: group.description,
        name: group.name,
        kpi: group.kpi
      }).then(() => {
        context.dispatch('updateAnimalsGroup', group).then(r => console.log("ALL OK: ", r));
      }).catch(err => {
        console.log("ERR: ", err);
      });
    },
    updateGroup(context, data) {
      let path = `users/${firebase.auth.currentUser.uid}/paddocks/${context.state.paddock.key}/groups/${data.key}/`
      firebase.firestore.doc(path).update({
        name: data.name,
        description: data.description
      }).then(() => {
        console.log("UPDATE GROUP OK");
      }).catch(err => {
        console.log("UPDATE GROUP ERR:", err);
      })
    },
    updateAnimalsGroup(context, group) {
      let data = {
        group: group.name,
        key: null,
      }
      group.animals.forEach(animal => {
        data.key = animal.key;
        context.dispatch('changeGroup', data).then(r => console.log("ALL OK: ", r));
      });
    },
    /**
     * Cambia el grupo de una vaca seleccionada por el usuario
     * @param context el contexto de la store
     * @param data datos necesarios para cambiar de grupo
     */
    changeCowGroup(context, data) {
      firebase.firestore.collection('users').doc(firebase.auth.currentUser.uid)
          .collection('animals').doc(data.cowKey).update({
        group: data.groupName,
      }).then(() => {
        const animals = context.state.animals;
        let actualGroup = [];
        animals.forEach(cow => {
          if (cow.group === context.state.group.name) {
            actualGroup.push(cow);
          }
        });
        context.commit('changeAnimalsInGroup', actualGroup);
        console.log('cow with key: ',  data.cowKey, ' has been updated with group: ', data.groupName);
      })
    },
    changeGroup(context, data) {
      let path = `users/${firebase.auth.currentUser.uid}/cows/${data.key}/`
      firebase.firestore.doc(path).update({
        group: data.group
      }).then(() => {
        console.log("CHANGE GROUP OK");
      }).catch(err => {
        console.log("CHANGE GROUP ERR:", err);
      })
    },
    changePaddock(context, data) {
      let path = `users/${firebase.auth.currentUser.uid}/cows/${data.key}/`
      firebase.firestore.doc(path).update({
        paddock: data.paddock
      }).then(() => {
        console.log("CHANGE PADDOCK OK");
      }).catch(err => {
        console.log("CHANGE PADDOCK ERR:", err);
      })
    },
    /**
     * Cambia el grupo de las vacas seleccionadas por el usuario
     * @param context el contexto de la store
     * @param cows vacas a las que se desea cambiar el grupo
     */
    changeFireCowsGroup(context, newGroup) {
      newGroup.cows.forEach(cow => {
        firebase.firestore.collection('users').doc(firebase.auth.currentUser.uid)
            .collection('animals').doc(cow.key).update({
          group: newGroup.name,
        }).then(() => {
          for (let i = 0; i < newGroup.cows.length; i++){
            newGroup.cows[i].name = newGroup.name;
          }
          console.log('cow with key: ',  cow.key, ' has been updated with group: ', newGroup.name);
        })
      });
      context.commit('changeAnimalsInGroup', newGroup.cows);
    },
    /**
     * Cambia el nombre del grupo actual
     * @param context el contexto de la store
     * @param newGroup el objeto grupo
     */
    changeFireGroupName(context, newGroup) {
      firebase.firestore.collection('users').doc(firebase.auth.currentUser.uid)
          .collection('paddocks').doc(context.state.paddockName.key).collection('groups').doc(context.state.group.key).update({
        name: newGroup.name,
        description: newGroup.description,
      }).then(() => {
        console.log('group with key: ', context.state.group.key, ' has been updated with name: ', newGroup.name);
        console.log('group with key: ', context.state.group.key, ' has been updated with description: ', newGroup.description);
      })
    },
    deleteGroup(context, data) {
      let groupPath = `users/${firebase.auth.currentUser.uid}/paddocks/${context.state.paddock.key}/groups/${data.key}`;
      firebase.firestore.doc(groupPath).delete().then(() => {
        console.log('group has been deleted');
        data.animals.forEach(animal => {
          let animalPath = `users/${firebase.auth.currentUser.uid}/${data.type}/${animal.key}`
          firebase.firestore.doc(animalPath).update({
            group: 'Establo general'
          }).then(() => {
            console.log('cow with key: ', animal.key, ' has been updated with group: Establo general');
            EventBus.$emit('closeInd');
          })
        })
      });
    },
    /**
     * Delete an animal saved in Firestore
     * @param context
     * @param payload
     */
    deleteAnimal(context, payload) {
      let animalRef = firebase.firestore.doc('users/' + firebase.auth.currentUser.uid + '/'
          + payload.animalType + '/' + payload.key);
      if (payload.soft) {
        animalRef.get().then(animal => {
          firebase.firestore.collection('users/' + firebase.auth.currentUser.uid + '/deleted')
              .add(animal.data()).then(() => {
            console.log('animal has been soft deleted');
            router.back();
            animalRef.delete().then(() => {
              console.log('animal has been hard deleted');
            }).catch(error => {
              console.log('something went wrong', error);
            });
          }).catch(error => {
            console.log('something went wrong', error);
          });
        });
      } else {
        animalRef.delete().then(() => {
          console.log('animal has been hard deleted');
          router.back();
        }).catch(error => {
          console.log('something went wrong', error);
        });
      }
    },
    /**
     *
     * @param context
     * @param keys the history's item id to delete
     */
    deleteHstHeat(context, keys) {
      let animalRef = firebase.firestore.collection('users/' + firebase.auth.currentUser.uid + '/cows');
      animalRef.doc(keys.animalKey + '/history/' + keys.hstKey).delete().then(() => {
        console.log("DEBUG: HISTORY ITEM DELETED");
        if (keys.type === 'heat') {
          animalRef.doc(keys.animalKey + '/heats/' + keys.heatKey).delete().then(() => {
            console.log("DEBUG: HEAT ITEM DELETED");
            EventBus.$emit('hideEvntSnack');
          });
        } else if (keys.type === 'preg' && keys.actualPreg) {
          console.log("DEBUG: PREG ITEM DELETED");
          animalRef.doc(keys.animalKey).update({
            pregDate: null,
          }).then(() => {
            EventBus.$emit('hideEvntSnack');
          })
        } else if (keys.type === 'health'){
          console.log("DEBUG: HEALTH ITEM DELETED");
          EventBus.$emit('hideEvntSnack');
        } else {
          console.log("Holi")
        }
      })
    },
    /**
     * Cambia el animal seleccionado para hacerle cambios
     * @param context el contexto actual
     * @param key la clave del animal
     */
    fireListenCurrentAnimal(context, key) {
      let animalRef = firebase.firestore.collection('users').doc(firebase.auth.currentUser.uid)
          .collection('cows').doc(key);
      animalRef.onSnapshot(async (snapshot) => {
            let currentCow = await snapshot.data();


            currentCow.key = key;
            context.commit('changeCurrentAnimal', currentCow);
      });
    },
    /**
     * Obtiene todos los ranchos previamente registrados por el usuario
     * @param context
     */
    async listenPaddocks(context) {
      const user = firebase.firestore.collection('users').doc(firebase.auth.currentUser.uid);
      user.collection('paddocks').onSnapshot((onSnapshot) => {
        let tempPaddocksArray = [];
        onSnapshot.forEach((doc) => {
          let tempPaddockData = doc.data();
          // añade la key para referenciar posteriormente a cada rancho
          tempPaddockData.key = doc.id;
          tempPaddocksArray.push(tempPaddockData);
        });
        context.commit('loadPaddocks', tempPaddocksArray);

        if (localStorage.paddock !== undefined) {
          let tmpName = JSON.parse(localStorage.getItem('paddock'));
          context.commit('setPaddock', tmpName);
        } else {
          context.commit('setPaddock', tempPaddocksArray[0]);
        }

        if (localStorage.animalType !== undefined) {
          let tmpType = localStorage.animalType;
          console.log(tmpType);
          context.commit('setAnimalType', tmpType);
        } else {
          context.commit('setAnimalType', 'cows');
        }

        context.dispatch('listenGroups').then(() => {
          context.dispatch('listenCows').then(() => {
            console.log('listen cows from firestore');
          });
          context.dispatch('listenBulls').then(() => {
            console.log('listen bulls from firestore');
          });
          context.dispatch('listenHeifers').then(() => {
            console.log('listen heifers from firestore');
          });
        });
      });
    },
    /**
     * Añade un nuevo rancho al sistema, una vez que el usuario ya ha iniciado sesión
     * @param context
     * @param newPaddock nuevo rancho a añadir en el sistema
     */
    saveExtraPaddock(context, newPaddock) {
      firebase.firestore.collection('users').doc(firebase.auth.currentUser.uid).collection('paddocks').add(newPaddock).then(() => {
        console.log('new paddock is added');
      });
    },
    /**
     * Actualiza el rancho seleccionado
     * @param context
     * @param updatePaddock
     */
    updateCurrentPaddock(context, updatePaddock) {
      firebase.firestore.collection('users').doc(firebase.auth.currentUser.uid).collection('paddocks').doc(context.state.paddockName.key).set(updatePaddock).then(() => {
        console.log('current paddock has been updated')
      });
    },
    /**
     * Guarda el primer rancho en la base de datos cuando el usuario está haciendo el registro
     * @param uid
     * @param newPaddock
     */
    saveNewPaddock(uid, newPaddock) {
      firebase.firestore.collection('users').doc(uid).collection('paddocks').add(newPaddock).then(() => {
        console.log('new paddock is added!');
      })
    },
    signIn(context, payload) {
      firebase.auth.signInWithEmailAndPassword(payload.user, payload.password).then(user => {
        context.commit('setUser', user);
        router.push('/Home');
      }).catch(err => {
        console.log("ERR: ", err);
      });
    },
    signUp(context, payload) {
      firebase.auth.createUserWithEmailAndPassword(payload.email, payload.password)
          .then((event) => {
            // primer rancho
            const firstPaddock = {
              name: payload.paddock,
              address: payload.address,
              defaultSiniiga: payload.defaultSiniigaCode,
            };
            firebase.firestore.collection('users').doc(event.user.uid).set({
              firstName: payload.name,
              lastName: payload.lastName,
              email: payload.email,
              paddockSelected: payload.paddock,
              phone: payload.phone,
              onboarding: false,
              alertsChannel:['Mail']
            }).then(() => {
              this.saveNewPaddock(event.user.uid, firstPaddock);
              router.push('/Home').then(() => {
                console.log('back to home');
              });
            });
          }).catch((error) => {
        // eslint-disable-next-line no-console
        console.log(error);
      });
    },
    async firstUserSet(context) {
      if (firebase.auth.currentUser.uid) {
        context.commit('setUser', firebase.auth.currentUser.uid);
        context.dispatch('listenPaddocks').then(() => {
          console.log('listen paddocks from firestore');
        });

        context.dispatch('getUserData').then(() => {
          console.log('listen user from firestore');
        });
      }
    },
    signOut(context) {
      firebase.auth.signOut().then(() => {
        context.commit('setUser', null);
        router.push('/Login').then((r) => {
          console.log("SIGNOUT: OK ", r);
        });
      }).catch(err => {
        console.log("ERR: ", err);
      });
    },
    /**
     * Saves an animal in the database, if this animal has a reproductive event do we store this also
     * @param context
     * @param payload an object with the information of animal to be store
     */
    saveAnimal(context, payload) {
      let uid = firebase.auth.currentUser.uid;
      firebase.firestore.collection('users/' + uid + '/' + payload.path).add(payload.animal)
          .then((animal) => {
            EventBus.$emit('hideSnack', false);
            // save the heat event
            if (payload.eventType === 'heat') {
              payload.event.key = animal.id;
              if (payload.event.waiting) {
                payload.event.typeHeat = 4;
                payload.event.description = 'Entró en periodo de espera voluntaria.';
              } else {
                payload.event.typeHeat = 5;
                payload.event.description = '¡Inseminación exitosa!'
              }
              this.dispatch('saveHeatAlert', payload.event);
            } else if (payload.eventType === 'preg') {
              payload.event.key = animal.id;
              this.dispatch('savePregnantAlert', payload.event);
            } else if (payload.eventType === 'birth') {
              saveHistoryItem(animal.id, payload.event, 'cows');
            }
      }).catch(error => {
        console.log(error);
      })
    },

    saveNewUserInfo(context, payload) {
      firebase.firestore.collection('users').doc(firebase.auth.currentUser.uid).update({
        firstName: payload.firstName,
        lastName: payload.lastName,
        phone: payload.phone
      });
      var user = firebase.auth.currentUser;
      if(payload.email !== user.email){
        user.updateEmail(payload.email).then(function() {

        }).catch(function(error) {
          console.log(error)
        });
      }
    },
    saveNewOnboardingStatus(context, payload) {
      firebase.firestore.collection('users').doc(firebase.auth.currentUser.uid).update({
        onboarding: payload.onboarding,
      }).then(()=>{
        router.push({name:'Home'});
      });
    },
    sendPasswordReset() {
      var user = firebase.auth.currentUser;
      firebase.auth.sendPasswordResetEmail(user.email).then(function() {
        // Email sent.
      }).catch(function(error) {
        console.log(error)
      });
    },
    /**
     * Guarda un evento de celo en la base de datos, además modifica los parámetros de la vaca seleccionada
     * y guarda un nuevo evento en sistema
     * @param context el contexto actual
     * @param payload el evento de celo
     */
    saveHeatAlert(context, payload) {
      // objeto bitácora
      let hstItem = {
        description: payload.description,
        type: 'heat',
        heatType: payload.typeHeat,
        date: payload.date,
        name: '',
        heatKey: '',
      }

      //aplica el nombre del evento en bitácora a partir del caso de celo
      switch (payload.typeHeat) {
        case 1:
          hstItem.name = 'No entró en celo';
          break;
        case 2:
          hstItem.name = 'Celo sucio con medicación';
          break;
        case 3:
          hstItem.name = 'Celo sucio sin medicación';
          break;
        case 4:
          hstItem.name = 'Tiempo de espera voluntaria';
          break;
        case 5:
          hstItem.name = 'Se inseminó a la vaca correctamente';
          hstItem.bull = payload.bull;
          break;
        default:
          console.error('typeHeat: ' + payload.typeHeat);
          break;
      }

      let heatItem = {
        confirmed: payload.confirmed,
        clean: payload.clean,
        treatment: payload.treatment,
        inseminated: payload.inseminated,
        waiting: payload.waiting,
        heat: payload.heat,
        bull: payload.bull,
        date: payload.date
      }

      let animalRef = firebase.firestore.doc('users/' + firebase.auth.currentUser.uid + '/cows/' + payload.key)
      let heatsRef = animalRef.collection('/heats');
      heatsRef.add(heatItem).then((evnt) => {
        console.log('heatItem saved!');
        hstItem.heatKey = evnt.id;
        saveHistoryItem(payload.key, hstItem, 'cows');
        animalRef.update({inHeat: 'registered'}).then(() => {
          EventBus.$emit('hideEvntSnack');
          console.log('inHeat changed!');
        }).catch(error => {
          console.log("something unexpected...", error);
        })
      });




      //
      // firebase.firestore.collection('users').doc(firebase.auth.currentUser.uid)
      //     .collection('animals').doc(payload.key).collection('heats')
      //     .add(payload).then(() => {
      //   console.log('new heatAlert added');
      // });

      // firebase.firestore.collection('users').doc(firebase.auth.currentUser.uid)
      //     .collection('animals').doc(payload.key).update({
      //   hUserConfirmed: payload.userConfirmation,
      //   isInHeat: payload.isInHeat,
      // }).then(() => {
      //   console.log('animal properties has changed');
      // // });
      // saveHistoryItem(payload.key, historyItem);
    },
    saveDeleteAlert(context, deleteEvent) {
      // objeto bitácora
      let deleteItem = {
        name: 'Borrado de animal',
        description: deleteEvent.reason,
      };
      saveHistoryItem(deleteEvent.key, deleteItem);},
    /**
     * Guarda un nuevo evento en la bitácora
     * @param context el contexto actual
     * @param payload el evento a guardar
     */
    savePregnantAlert(context, payload) {
      // objeto bitácora
      let pregItem = {
        description: payload.description,
        type: 'preg',
        pregnant: payload.isPregnant,
        method: payload.method,
        date: payload.date,
        name: payload.name,
      };

      let animalRef = firebase.firestore.doc('users/' + firebase.auth.currentUser.uid + '/cows/' + payload.key);

      if (payload.type > 2) {
        return true;
      } else {
        animalRef.update({
          pregDate: payload.date,
        }).then(() => {
          saveHistoryItem(payload.key, pregItem, 'cows');
          EventBus.$emit('hideEvntSnack');
          console.log("GESTATION: TRUE");
        }).catch(err => {
          console.log("GESTATION: ", err);
        });
      }
      /*saveHistoryItem(payload.key, historyItem);*/
    },
    saveBirthAlert(context, payload) {
      let animalRef = firebase.firestore.doc('users/' +
          firebase.auth.currentUser.uid + '/cows/' + payload.key);

      let heatsRef = animalRef.collection('/heats');

      heatsRef.get().then(querySnap => {
        querySnap.forEach(doc => {
          heatsRef.doc(doc.id).delete().then(() => {
            EventBus.$emit('hideEvntSnack');
            console.log("DEBUG: DELETE");
          }).catch(err => {
            console.log("DEBUG: ", err);
          });
        })
      });

      animalRef.update({
        calving: {
          date: payload.date,
          abort: payload.abort
        },
        pregDate: null,
        inHeat: 'not_yet'
      }).then(() => {
        console.log("BIRTH: SAVED");
      }).catch(err => {
        console.log("BIRTH: ", err);
      });

      let hstItem = {
        name: payload.abort ? 'Aborto' : 'Parto',
        type: 'birth',
        description: payload.description,
        date: payload.date,
        sick: payload.abortSick,
        abortType: payload.abortType,
        abortReason: payload.abortReason
      };

      if (!payload.abort) {
        hstItem.abortType = null;
        hstItem.abortReason = null;
        hstItem.sick = null;
      }
      saveHistoryItem(payload.key, hstItem, 'cows');
    },
    async saveHealthAlert(context, payload) {
      let tmpType = payload.type;
      payload.type = 'health';
      let animalRef = firebase.firestore.doc('users/' + firebase.auth.currentUser.uid + '/cows/' + payload.key);
      animalRef.collection('history').add(payload).then(item => {
        let animalHealth = null;
        if (tmpType === 'sick' || tmpType === 'chg') {
          animalHealth = {
            sick: payload.treatment.sick,
            key: item.id
          }
          animalRef.update({
            health: animalHealth
          }).then(() => {
            EventBus.$emit('hideEvntSnack');
            console.log("PROPERTIES CHANGED");
          })
        } else {
          animalRef.update({
            health: null
          }).then(() => {
            EventBus.$emit('hideEvntSnack');
            console.log("PROPERTIES CHANGED");
          })
        }
      });

    },
    setAnmPaddock(state, payload) {
      let animalRef = firebase.firestore.doc('users/' + firebase.auth.currentUser.uid + '/cows/' + payload.key);
      animalRef.update({
        paddock: payload.paddock
      }).then(() => {
        console.log("DEBUG: PADDOCK CHANGED");
      })
    },
    /**
     * Aplica dos filtros para la selección de vacas. En primera instancia
     * revisa si el primer filtro es Manual o Automático,
     * si es Manual entonces procede a filtrar a todas las vacas que tengan como grupo Establo General.
     * Si es Automático, entonces filtra las características correspondientes para
     * Establo General, Alta Producción, Secas o en Reto, Recién Paridas y Enfermas.
     * En ambos casos y después de hacer el primer filtro, hace un segundo filtro
     * seleccionando los animales que cumplan con las siguientes características dadas
     * por el usuario: Raza, No. de Lactancias y Edad
     * @param context el contexto de la store
     * @param userInput la entrada del usuario
     */
    changeFilteredCows(context, userInput) {
      let result = []; // array para mutar a filteredCows
      let animals = this.state.animals; // animales en el sistema
      let firstAnimalsFiltered = []; // array con los animales resultantes del primer filtro
      console.log(userInput);
      // primer filtro
      if (userInput.paddockType === 'Manual') {
        animals.forEach(cow => {
          if (cow.group === 'Establo general') {
            firstAnimalsFiltered.push(cow);
          }
        });
      } else if (userInput.paddockType === 'Automatic') {
        switch (userInput.groupName) {
          case 'Alta producción':
            animals.forEach(cow => {
              if (cow.group === 'Establo general') {
                firstAnimalsFiltered.push(cow);
              }
            });
            break;
          case 'Secas o en reto':
            animals.forEach(cow => {
              if (cow.milkState === 'Seca') {
                firstAnimalsFiltered.push(cow);
              }
            });
            break;
          case 'Recién paridas':
            animals.forEach(cow => {
              if (cow.group === 'Establo general') {
                firstAnimalsFiltered.push(cow);
              }
            });
            break;
          case 'Enfermas':
            console.log('enfermas');
            /*animals.forEach(cow => {
              /!*if (cow.isSick) {
                firstAnimalsFiltered.push(cow);
              }*!/
            });*/
            break;
          default:
            firstAnimalsFiltered = animals;
            break;
        }
      }

      if (userInput.selectionType === 'Manual' || userInput.selectionType === 'Automatic') {
        // segundo filtro
        switch (userInput.firstFilter) {
          case 'lactation':
            firstAnimalsFiltered.forEach(animal => {
              userInput.secondFilter.forEach(year => {
                if (year === 'more' && animal.lactationCycle > 6) {
                  result.push(animal);
                } else {
                  // noinspection EqualityComparisonWithCoercionJS
                  if (animal.lactationCycle == year) {
                    result.push(animal);
                  }
                }
              });
            });
            break;
          case 'breed':
            result = firstAnimalsFiltered.filter(animal => animal.breed === userInput.secondFilter);
            break;
          case 'age':
            firstAnimalsFiltered.forEach(animal => {
              let animalBirthday = moment(animal.birthday);
              let tempAge = moment().diff(animalBirthday, 'years');
              userInput.secondFilter.forEach(year => {
                if (year === 'more' && tempAge > 6) {
                  result.push(animal);
                } else {
                  // noinspection EqualityComparisonWithCoercionJS
                  if (tempAge == year) {
                    result.push(animal);
                  }
                }
              });
            });
            break;
          default:
            result = firstAnimalsFiltered;
            break;
        }
      }
      // mutación para filteredCows
      context.commit('filterCows', result);
    },
  },
});
